import { OfferProperties } from 'src/@types/offer-properties';

const MAX_AUTOMATED_CLOSING_FUNDED_AMOUNT = 150_000;

export const isAutomatedClosingEligible = (offerProperties: OfferProperties) =>
  offerProperties.requestedAmount <= MAX_AUTOMATED_CLOSING_FUNDED_AMOUNT;

export const isRequestedAmountAutomatedClosingEligible = (requestedAmount?: number) => {
  if (!requestedAmount) return false;

  return requestedAmount <= MAX_AUTOMATED_CLOSING_FUNDED_AMOUNT;
};
